import HttpService from "./http.service";

class CPManagersService extends HttpService {
  list = (params) => this.get("cp/list", params);

  contractList = (id, params) => this.get(`contract/cp/${id}`, params);

  createContract = (id, data) => this.post(`contract/store/${id}`, data);

  editContract = (id, data) => this.patch(`contract/${id}`, data);

  createCP = (data) => this.post(`cp/store`, data);

  uploadCPs = (data) => this.post(`common/upload-cp`, data);

  getCP = (id) => this.get(`cp/${id}`);

  update = (id, data) => this.put(`suppliers/job/${id}`, data);

  editCp = (id,data) => this.patch(`cp/${id}`, data);


}

export default new CPManagersService();
